import { make as ModalWithButton } from 'components/library/ModalWithButton.bs';
import { ActionType, PaypalStatus } from 'reducers/ProductPageReducer';
import { useProduct } from 'contexts/ProductPageContext';

const PaypalCancelledModal = (): JSX.Element => {
  const { dispatch, state } = useProduct() || {};
  return (
    <ModalWithButton
      visible={state.paypal == PaypalStatus.Cancelled}
      heading="Transaction Cancelled"
      text="Your PayPal transaction was cancelled. Your PayPal account was not charged."
      button="OK"
      onButtonClick={() => {
        dispatch({ type: ActionType.PaypalIdle });
      }}
    />
  );
};

export default PaypalCancelledModal;
